import initialState from '../store/initialState'
import preferencesTypes from '../constants/preferencesTypes'

const { toast } = window.M

export default function preferencesReducer(state = initialState.preferences, action) {
  //console.log(action.type)
  switch (action.type) {

    case preferencesTypes.reset: {
      return {
        ...initialState.preferences
      }
    }

    case preferencesTypes.reset_errors: {
      return {
        ...state,
        errors: []
      }
    }

    // INDEX
    case preferencesTypes.index.request: {
      return {
        ...state,
        errors: [],
        fetching: true,
        fetched: false
      }
    }

    case preferencesTypes.index.success: {
      return {
        ...state,
        errors: [],
        fetching: false,
        fetched: true,
        preferences: action.payload.preferences
      }
    }

    case preferencesTypes.index.failure: {
      toast({
        html: action.payload
      })
      return {
        ...state,
        errors: action.payload,
        fetching: false,
        fetched: false
      }
    }

    // UPDATE
    case preferencesTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case preferencesTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        preferences: action.payload.preferences
      }
    }

    case preferencesTypes.update.failure: {
      toast({
        html: action.payload
      })
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }


    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/preferencesReducer.js